document.addEventListener('DOMContentLoaded', function () {
    const jsCoursesBody = document.querySelectorAll('.jsCoursesBody');

    for (let index = 0; index < jsCoursesBody.length; index++) {
        let body = jsCoursesBody[index];
        let content = body.querySelector('.jsCoursesContent');
        let button = body.querySelector('.jsCoursesMore');   

        if(body.offsetHeight < content.offsetHeight) {
            button.classList.add('is-visible')
        } else {
            button.classList.remove('is-visible')
        }

        button.addEventListener('click', () => {
            body.classList.toggle('is-active');

            if(body.classList.contains('is-active')){
                body.style.maxHeight = content.offsetHeight + 'px';
            } else {
                body.style.maxHeight = '';
            }
        })
    }
})

